import { localize, extend } from "vee-validate";
import * as Rules from "vee-validate/dist/rules";


for (const [rule, validation] of Object.entries(Rules)) {
  extend(rule, {
    ...validation
  });
}
